/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ share: NonNullable<unknown> }} Statsshareofaccounts3Inputs */

const en_statsshareofaccounts3 = /** @type {(inputs: Statsshareofaccounts3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.share} of all accounts`)
};

const de_statsshareofaccounts3 = /** @type {(inputs: Statsshareofaccounts3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.share} aller Konten`)
};

/**
* | output |
* | --- |
* | "{share} of all accounts" |
*
* @param {Statsshareofaccounts3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsshareofaccounts3 = /** @type {((inputs: Statsshareofaccounts3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsshareofaccounts3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsshareofaccounts3(inputs)
	return de_statsshareofaccounts3(inputs)
});
export { statsshareofaccounts3 as "statsShareOfAccounts" }